<template>
    <div class="background-image">  
      <div class="container">
        <div class="content ">
            <div class="row m-10"> 
              <div class="d-flex justify-content-center align-items-center">
                <a class="mb-12 text-center d-flex justify-content-center align-items-center">
                  <span class="bg-white p-2 rounded-3"><Img alt="Logo" filename="logo.png" class="h-50px"/></span>
                  <span class="ms-5 text-primary fw-bolder" style="font-size: 50px;">{{tenantId?.toUpperCase() || 'SUITE'}}</span>
                </a>
              </div>
                <form v-if="validity && !getting" class="fo rounded-2rm w-100" id="kt_kyc_form" @submit.prevent="submitResponse">
                    <Card class="card p-5" :title="nps?.title">
                        <div class="modal-body">
                            <Card class="card p-5 justify-ceontent-center align-items-center">
                                <Label labelClass="form-label fs-3 fw-bolder" :label="nps?.nps_description" :required="true"/>
                                <NpsInput v-model="formData.note" v-if="nps.icon == ICONS.EMOJI" :type="ICONS.EMOJI"/>
                                <NpsInput  v-model="formData.note" v-if="nps.icon == ICONS.STAR" :type="ICONS.STAR"/>
                            </Card>
                            <br>
                            <FormField
                                v-for="field in nps?.form?.fields" 
                                :key="field.id"
                                :form-data="field"
                                :form-errors="formErrors"
                                :withId="false"
                                v-model="formData" /> 
                        </div>
                        <template #cardFooter> 
                           <div class="d-flex justify-content-end">
                                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.reset" @click="resetForm"></Button>
                                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :loading="loading" @click="handleFormSubmit"></Button>
                            </div> 
                        </template>
                    </Card>
                </form>
                <Card v-if="!validity && !getting" class="card px-5 py-20">
                  <div class=" text-center justify-content-center align-items-center">
                    
                    <h2 class="fs-2x fw-bolder mb-0">{{ $t('nps.alwredyAnswered') }}</h2>
                   

                  </div>
                </Card>
            </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import {useLocales} from "@/composables/locales";
import Card from "@/components/Card.vue";
import FormField from "@/components/Form/FormField.vue";
import { useNpsIcon } from "../../composable/useNpsIcon";
import { reactive } from "vue";
import Button from "@/components/Button.vue";
import Label from "@/components/Form/Label.vue";
import NpsInput from "../../components/Inputs/NpsInput.vue";
import Img from "@/components/Img.vue";
import { getTenantId } from '@/mixins/Helpers';
  
  const route = useRoute()
  const router = useRouter()
  
  const store = useStore()
  const { ICONS } = useNpsIcon()
  const { locale } = useLocales()
  const tenantId = getTenantId()?.slice(0, -1)
  
  const title = ref("breadcrumbs.nps")
  const breadcrumbs = ref([
  {
    name: 'breadcrumbs.preview',
    route: 'nps'
  }
  ])
  
  const getting = ref(false)
  const loading = ref(false)

  const nps = ref({})

  const validity = ref()
  const formData = reactive({
    note: "",
    nps_id: route.params.id,
    invitation_id: route.params.invitation
  })
  const formErrors = ref({})

  const form = ref({
    checkValidity: true,
    id: route.params.id,
    invitation: route.params.invitation
  })
  
  const company = computed(() => store.getters['offices/getSelectedCompany'])
  
  watch(() => [route.params.id,route.params.invitation], () => {
    if(route.params.id){
      loadNps()
    }
  })
  
  const loadNps= () => {
    getting.value = true
    store.dispatch('nps/getClienNps', form.value).then((resp) => {
      nps.value = resp.data.data
      validity.value = resp.data.formIsValid
      initForm(resp.data.data)
    })
    .finally(() => getting.value = false)
  }
  
  
  function submitResponse(){
    loading.value = true
    store.dispatch('nps/saveNpsResponse', formData)
        .then(res => {
          window.toastr['success'](i18n.global.t("notification.nps_response_submited"))
          validity.value = false
        })
        .catch((err) => {
        })
        .finally(() => loading.value = false)
  }

  
  function initForm(nps){
    
  }
  
  onMounted(() => {
    if(route.params.id){
      loadNps()
    }
  })
  
  </script>
  <style scoped>
  .container {
    
  }
  
  .content {
  }
  
  .icon {
    font-size: 50px;
    margin-bottom: 20px;
  }
  
  .background-image {
    background: 
        linear-gradient(rgba(0, 114, 206, 0.1), rgba(240, 120, 23, 0.1)),
        url('../../../../../public/assets/media/empty_bg.png') no-repeat center center,
        url('../../../../../public/assets/media/empty_bg.png') no-repeat center center;
    background-size: cover, cover, cover;
    height: 100vh;
    width: 100%; 
  }
  </style>